import { render, staticRenderFns } from "./GatDynaFields.vue?vue&type=template&id=0c33c171&scoped=true&"
import script from "./GatDynaFields.vue?vue&type=script&lang=js&"
export * from "./GatDynaFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c33c171",
  null
  
)

export default component.exports